var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-warning",attrs:{"role":"alert"}},[_c('strong',[_vm._v(_vm._s(this.mesage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }